import { Attr, HasOne, Model } from "spraypaint";

import SourceRecord from "shared/resources/SourceRecord";

import type Category from "./Category";
import type CopyrightAgency from "./CopyrightAgency";
import type Outlet from "./Outlet";
import type SourceGroup from "./SourceGroup";

@Model()
class Newspaper extends SourceRecord {
  static jsonapiType = "newspapers";

  @Attr() aliases: string[];

  @Attr({ persist: false }) archivedAt: string;

  @Attr() audienceFileIdentifier: string;

  @Attr() caldContent: string;

  @HasOne() category: Category;

  @Attr() categoryId: number;

  @HasOne() copyrightAgency: CopyrightAgency;

  @Attr() copyrightAgencyId: number;

  @Attr({ persist: false }) createdAt: string;

  @Attr() dailyAudience: number;

  @Attr() externalId: string;

  @Attr() filenamePattern: string;

  @Attr() frontPageReportEnabled: boolean;

  @Attr() frontPageReportOrder: number;

  @Attr() internationalMax: number;

  @Attr() label: string;

  @Attr() lastArticleAt: string;

  @Attr() locationId: number;

  @Attr() logoData: string;

  @Attr({ persist: false }) medium: string;

  @Attr() notes: string;

  @Attr() origin: string;

  @HasOne() outlet: Outlet;

  @Attr() outletId: number;

  @Attr() relatedWebsiteId: number;

  @Attr() satirical: boolean;

  @HasOne() sourceGroup: SourceGroup;

  @Attr() sourceGroupId: number;

  @Attr() subscriptionExpiry: string;

  @Attr() syndication: boolean;

  @Attr() tier: number;

  @Attr() translate: boolean;

  @Attr({ persist: false }) updatedAt: string;

  @Attr() visible: boolean;
}

export default Newspaper;
